// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Mukta_2edd3d', '__Mukta_Fallback_2edd3d'","fontWeight":400,"fontStyle":"normal"},"className":"__className_2edd3d","variable":"__variable_2edd3d"};